import { createStore, applyMiddleware, compose, combineReducers } from "redux";
import thunk from "redux-thunk";

import { reducers as customerReducer } from "./modules/sc-customer";
import { reducers as adminReducer } from "./modules/sc-admin";
import { reducers as licenseReducer } from "./modules/sc-licensePrototype";
import { reducers as userReducer } from "./modules/sc-users";
import { reducers as reportsReducer } from "./modules/sc-reports";
import { reducers as printQueueReducer } from "./modules/sc-printQueue";
import { reducers as serverInstanceReducer } from "./modules/sc-serverInstance";
import { reducers as statisticReducer } from "./modules/sc-dashboard";
import { reducers as settingReducer } from "./modules/sc-settings";
import { reducers as productReducer } from "./modules/sc-product";
import { reducers as paletteReducer } from "./modules/sc-palette";
import { reducers as orderReducer } from "./modules/sc-order";
import { reducers as billingReducer } from "./modules/sc-billing";
import { reducers as vehicleReducer } from "./modules/sc-vehicle";
import { reducers as translateReducer } from "./modules/sc-translate";
import { reducers as exportImportReducer } from "./modules/sc-download";
import { reducers as rolesReducer } from "./modules/sc-roles";
import { reducers as tableViewReducer } from "./modules/sc-tableView";
import { reducers as trialVoucherReducer } from "./modules/sc-trialVoucher";
import { reducers as downloadReducer } from "./modules/sc-downloadAll";
import { reducers as networkZoneReducer } from "./modules/sc-networkZone";
import { reducers as logisticReducer } from "./modules/sc-logistic";
import { reducers as clientReducer } from "./modules/Assets/sc-client";
import { reducers as warehousesReducer } from "./modules/sc-warehouses";
import { reducers as mediaReducer } from "./modules/sc-media";
import { reducers as activeCustomerReducer } from "./modules/sc-activeCustomer";
import { reducers as customerErasureMethodReducer } from "./modules/sc-customerErasureMethod";
import { reducers as externalSystemSettingReducer } from "./modules/sc-externalSystemSettings";

// Import custom module reducers
import { reducers as coreReducers } from "./modules/sc-core";
// Compose Enhancers
const composeEnhancers = (process.env.NODE_ENV === "development" ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : null) || compose;

// Root Reducer
const rootReducer = combineReducers({
    core: coreReducers,
    statistic: statisticReducer,
    printQueue: printQueueReducer,
    reports: reportsReducer,
    license: licenseReducer,
    customer: customerReducer,
    admin: adminReducer,
    user: userReducer,
    server: serverInstanceReducer,
    setting: settingReducer,
    product: productReducer,
    palette: paletteReducer,
    order: orderReducer,
    billing: billingReducer,
    vehicle: vehicleReducer,
    translate: translateReducer,
    role: rolesReducer,
    system: tableViewReducer,
    exportImport: exportImportReducer,
    trialVoucher: trialVoucherReducer,
    download: downloadReducer,
    networkZone: networkZoneReducer,
    logistic: logisticReducer,
    warehouses: warehousesReducer,
    client: clientReducer,
    media: mediaReducer,
    activeCustomer: activeCustomerReducer,
    customerErasureMethod: customerErasureMethodReducer,
    externalSystemSettings: externalSystemSettingReducer,
});

// Create store
const store = createStore(rootReducer, composeEnhancers(applyMiddleware(thunk)));

export default store;

export const getRootReducer = reducerName => {
    let currentState = store?.getState() || {};
    return currentState[reducerName] || null;
}

export const getUserSetting = () => {
    let rootReducer = getRootReducer('core');
    return rootReducer?.login?.userSettings;
}

export const getUser = () => {
    let rootReducer = getRootReducer('core');
    return rootReducer?.login?.user;
}

export const getUserPermissions = () => {
    let rootReducer = getRootReducer('core');
    return rootReducer?.login?.permissions;
}